/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Comparison_Product_Hunt_Rows_Listing_LeftInputs */

const en_directory_comparison_product_hunt_rows_listing_left = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Listing_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Structured product detail with taxonomy and alternatives`)
};

const zh_directory_comparison_product_hunt_rows_listing_left = /** @type {(inputs: Directory_Comparison_Product_Hunt_Rows_Listing_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`带分类和替代方案的结构化产品详情`)
};

/**
* | output |
* | --- |
* | "Structured product detail with taxonomy and alternatives" |
*
* @param {Directory_Comparison_Product_Hunt_Rows_Listing_LeftInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_comparison_product_hunt_rows_listing_left = /** @type {((inputs?: Directory_Comparison_Product_Hunt_Rows_Listing_LeftInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Comparison_Product_Hunt_Rows_Listing_LeftInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_comparison_product_hunt_rows_listing_left(inputs)
	return zh_directory_comparison_product_hunt_rows_listing_left(inputs)
});
export { directory_comparison_product_hunt_rows_listing_left as "directory.comparison.product_hunt.rows.listing.left" }